<template>
  <div>
    <b-card title="Welcome to Forest - NTDC Portal 🚀" class="text-center">
      <b-card-text>
        <h4 class="text-primary">
          Please select menu <br class="d-flex d-md-none" />
          from Sidebar or Navbar
        </h4>
      </b-card-text>
      <b-img fluid :src="imgUrl" class="custom-max-height" alt="Login V2" />
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink, BImg } from "bootstrap-vue"
import VueScreenSize from "vue-screen-size"
import store from "@/store/index"

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
  },
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data() {
    return {
      img: require("@/assets/images/pages/login-v2-dark.svg"),
    }
  },

  computed: {
    isInternalLogin() {
      return this.$route.fullPath.toLowerCase().includes("internal")
    },
    imgUrl() {
      if (!this.isInternalLogin) {
        this.img = require("@/assets/images/pages/reset-password-v2.svg")
        return this.img
      }
      return this.img
    },
    screenWidth() {
      return this.$vssWidth
    },
  },

  watch: {
    screenWidth: {
      deep: true,
      immediate: true,
      handler() {
        if (this.screenWidth < 1200) {
          store.dispatch("appConfig/setLayoutSidebar", true)
        } else {
          store.dispatch("appConfig/setLayoutSidebar", false)
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-max-height {
  max-height: 475px;
}
</style>
